import { render } from "./edit-company-info.vue?vue&type=template&id=43491306&scoped=true"
import script from "./edit-company-info.vue?vue&type=script&lang=js"
export * from "./edit-company-info.vue?vue&type=script&lang=js"

import "./edit-company-info.vue?vue&type=style&index=0&id=43491306&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43491306"]])

export default __exports__